// import { useEffect, useMemo, useState } from "react";
// import PropTypes from "prop-types";
// import { useNavigate } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// import axios from "axios";
// import { v4 as uuidv4 } from "uuid";

// // MUI Components
// import {
//   Card, Icon, LinearProgress, Button, Divider, Select, MenuItem,
//   Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Tooltip, TextField
// } from "@mui/material";
// import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";

// // Material Dashboard 2 Components
// import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";

// // Redux Slices
// import { setIsVehicle, setAutoLoadRoute } from "../../../features/vehicle/vehicleSlice";
// import { setModalVisible, setModelThing } from "features/planning/planningSlice";

// function Projects({ searchQuery, onVehicleSelect }) {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   // 👇 DATA AB DIRECTLY REDUX SE AA RAHA HAI
//   const { myThings, latestUpdates, selectedVehicleNumber, activeFilter } = useSelector((state) => state.fleet);
//   const things = useSelector((state) => state.things.filterThing || []);
//   const sessionToken = useSelector((state) => state.auth?.token || localStorage.getItem("token"));

//   // === Existing States (Same as before) ===
//   const [apiModalOpen, setApiModalOpen] = useState(false);
//   const [apiStep, setApiStep] = useState("confirm");
//   const [hours, setHours] = useState(0);
//   const [minutes, setMinutes] = useState(5);
//   const [tempLink, setTempLink] = useState("");
//   const [tempApiKey, setTempApiKey] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [journeys, setJourneys] = useState([]);
//   const [selectedJourney, setSelectedJourney] = useState("");

//   const [streamModalOpen, setStreamModalOpen] = useState(false);
//   const [currentVehicleForStream, setCurrentVehicleForStream] = useState("");
//   const [activeCameras, setActiveCameras] = useState([]);
//   const [loadingStreams, setLoadingStreams] = useState(false);
//   const [selectedCameras, setSelectedCameras] = useState([]);
//   const [gridSize, setGridSize] = useState(4);
//   const [showActiveOnly, setShowActiveOnly] = useState(false);
//   const [streamingAction, setStreamingAction] = useState({ loading: false, id: null });
//   const [snackbar, setSnackbar] = useState({ open: false, message: "", color: "success" });

//   const selectedThing = things.find((e) => e.id === searchQuery);
//   const hasTempLink = !!selectedVehicleNumber?.tempApiKey;

//   const API_BASE = "https://v3.dhundhoo.com";
//   // const sessionToken = useSelector((state) => state.auth?.token || localStorage.getItem("token"));

//   const apiCall = async (url, method = "POST", body) => {
//     setLoading(true);
//     try {
//       // Ensure raw token is used
//       const cleanToken = sessionToken ? sessionToken.replace("Bearer ", "").trim() : "";

//       const response = await axios({
//         url: url.startsWith("http") ? url : `${API_BASE}${url}`,
//         method: method,
//         data: body,
//         headers: {
//           "x-dhundhoo-session": cleanToken,
//         },
//       });

//       // Axios stores the response in .data
//       const data = response.data;

//       // Check for "Internal Server Error" within a 200 response
//       if (data.message === "Internal Server Error" || data.error) {
//         throw new Error(data.message || "Backend processing failed");
//       }

//       return data;
//     } catch (err) {
//       const errorMsg = err.response?.data?.message || err.message || "API Error";
//       alert(errorMsg);
//       throw err;
//     } finally {
//       setLoading(false);
//     }
//   };

//   // === Data Logic (Logic wahi hai, sirf source Redux hai) ===
//   const vehicles = useMemo(() => {
//     if (!myThings) return [];

//     const now = Date.now();

//     return Object.entries(myThings)
//       .map(([vehicleNumber, data]) => {
//         const update = latestUpdates[vehicleNumber];
//         const latest = update?.MOBILE || update?.GPS || update?.latest?.MOBILE || update?.latest?.GPS || {};
//         const raw = latest?.raw || {};
//         const updatedAt = latest?.updatedAt || data?.latest?.MOBILE?.updatedAt || null;

//         const journeyAvailable = data?.journeyAvailable === true;
//         const journeyData = data?.currentJourney || {};

//         return {
//           vehicleNumber,
//           nickName: data?.thing?.nickName || "N/A",
//           ignition: latest?.raw?.IGNITION?.toString() === "1" ? "ON" : "OFF",
//           time: updatedAt ? new Date(updatedAt).toLocaleString("en-IN") : "N/A",
//           rawTime: updatedAt ? new Date(updatedAt).getTime() : 0,
//           speed: latest?.speed ? parseFloat(latest.speed) : 0,
//           signal: raw?.SIGNAL_STRENGTH ? parseFloat(raw.SIGNAL_STRENGTH).toFixed() : "0",
//           satellites: raw?.TOTAL_SATELLITE || 0,
//           tempThing: data?.thing?.tempThing || null,
//           journeyAvailable,
//           route: journeyAvailable ? `${journeyData?.journeyName || "N/A"} ${journeyData?.type || "N/A"}` : "N/A",
//           status: data?.journeyStatus || "0 / 0",
//           progress: data?.progress || 0,
//         };
//       })
//       .filter((vehicle) => {
//         const q = (searchQuery || "").toLowerCase().trim();
//         const isStale = vehicle.rawTime + 3600000 < Date.now();

//         if (q.startsWith("@") && q !== "@total") {
//           if ("@running".startsWith(q)) return !isStale && vehicle.ignition === "ON" && vehicle.speed >= 0.25;
//           if ("@idle".startsWith(q)) return !isStale && vehicle.ignition === "ON" && vehicle.speed < 0.25;
//           if ("@parked".startsWith(q) || "@stopped".startsWith(q)) return !isStale && vehicle.ignition === "OFF";
//           if ("@offline".startsWith(q)) return isStale;
//         }

//         if (!q || q === "@total") {
//           if (activeFilter === "@running") return !isStale && vehicle.ignition === "ON" && vehicle.speed >= 0.25;
//           if (activeFilter === "@idle") return !isStale && vehicle.ignition === "ON" && vehicle.speed < 0.25;
//           if (activeFilter === "@parked") return !isStale && vehicle.ignition === "OFF";
//           if (activeFilter === "@offline") return isStale;
//           return true;
//         }

//         return (
//           vehicle.vehicleNumber.toLowerCase().includes(q) ||
//           vehicle.nickName.toLowerCase().includes(q)
//         );
//       })
//       .sort((a, b) => b.rawTime - a.rawTime);
//   }, [myThings, latestUpdates, activeFilter, searchQuery]);

//   const handleCreateLink = async () => {
//     if (!selectedVehicleNumber) {
//       alert("Vehicle not selected");
//       return;
//     }

//     try {
//       const duration =
//         (parseInt(hours) || 0) * 60 +
//         (parseInt(minutes) || 0);

//       const generatedKey = uuidv4();

//       const payload = {
//         thingId: selectedVehicleNumber,
//         tempApiKey: generatedKey,
//         expireTimeInMinutes: duration,
//       };

//       const data = await apiCall(
//         "/tempUrl/save",
//         "POST",
//         payload
//       );

//       const weblink = `https://boat.routegrip.com/live_temp?apiKey=${generatedKey}&thingId=${selectedVehicleNumber}`;

//       setTempLink(weblink);

//       setTempApiKey(generatedKey);

//       setTimeout(() => {
//         setApiStep("success");
//       }, 100);

//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const handleUpdateLink = async () => {
//     if (!tempApiKey || !selectedVehicleNumber) return;
//     try {
//       const duration = (parseInt(hours) || 0) * 60 + (parseInt(minutes) || 0);

//       const payload = {
//         thingId: selectedVehicleNumber,
//         tempApiKey: tempApiKey,
//         expireTimeInMinutes: duration,
//       };

//       await apiCall("/tempUrl/update", "POST", payload);

//       // Generate the link for display (same as create logic)
//       const weblink = `https://boat.routegrip.com/live_temp?apiKey=${tempApiKey}&thingId=${selectedVehicleNumber}`;

//       setTempLink(weblink);
//       // setApiStep("success");
//       setTimeout(() => {
//         setApiStep("success");
//       }, 100);
//       openSnackbar("Temporary URL updated successfully");
//     } catch (err) {
//       openSnackbar(err.message || "Failed to update URL", "error");
//     }
//   };

//   const handleDeleteLink = async () => {
//     if (!tempApiKey || !selectedVehicleNumber) return;
//     try {
//       const payload = {
//         thingId: selectedVehicleNumber,
//         tempApiKey,
//       };

//       await apiCall("https://camera.dhundhoo.com/tempUrl/delete", "POST", payload);
//       alert("Link deleted!");
//       setApiModalOpen(false);
//     } catch (err) { }
//   };

//   const resetModal = () => {
//     setApiStep("confirm");
//     setHours(0);
//     setMinutes(30);
//     setTempLink("");
//     setTempApiKey("");
//   };

//   const openSnackbar = (message, color = "success") => {
//     setSnackbar({ open: true, message, color });
//   };

//   const closeSnackbar = () => setSnackbar({ ...snackbar, open: false });

//   const openApiModal = (action = "create") => {
//     resetModal();
//     if (action === "update" && selectedVehicleNumber?.tempApiKey) {
//       setTempApiKey(selectedVehicleNumber.tempApiKey);
//       setApiStep("time");
//     } else if (action === "delete" && selectedVehicleNumber?.tempApiKey) {
//       setTempApiKey(selectedVehicleNumber.tempApiKey);
//       setApiStep("delete");
//     }
//     setApiModalOpen(true);
//   };

//   // === Helper Functions (No changes in logic) ===
//   const getVehicleStatusColor = (ignition, speed, rawTime) => {
//     const now = Date.now();
//     const isStale = rawTime && rawTime + 3600000 < now;
//     const spd = speed * 1.94384;
//     if (isStale) return "secondary";
//     if (ignition === "OFF") return "error.main";
//     return spd > 0 ? "success.main" : "warning.main";
//   };

//   const getSpeedStatusText = (ignition, speed, rawTime) => {
//     const now = Date.now();
//     const isStale = rawTime && rawTime + 3600000 < now;
//     const spd = speed * 1.94384;
//     if (isStale) return "Offline";
//     if (ignition === "OFF" && spd === 0) return "Parked";
//     if (ignition === "ON" && spd === 0) return "Idle";
//     if (ignition === "ON" && spd > 0) return "Running";
//     return "N/A";
//   };

//   const getSpeedTextColor = (ignition, speed, rawTime) => {
//     const now = Date.now();
//     const isStale = rawTime && rawTime + 3600000 < now;
//     const spd = speed * 1.94384;
//     if (isStale) return "secondary";
//     if (ignition === "OFF" && spd === 0) return "error";
//     if (ignition === "ON" && spd === 0) return "warning";
//     if (ignition === "ON" && spd > 0) return "success";
//     return "text";
//   };

//   // Signal strength (%) -> color: strong = green, moderate = orange, weak = red, offline = grey
//   const getSignalColor = (signal, isStale) => {
//     if (isStale) return "secondary"; // 👈 Offline par grey color

//     const sig = parseFloat(signal);
//     if (isNaN(sig)) return "text";
//     if (sig >= 70) return "success";
//     if (sig >= 40) return "warning";
//     return "error";
//   };

//   // Satellite count -> color: good = green, weak = orange, poor = red, offline = grey
//   const getSatelliteColor = (satellites, isStale) => {
//     if (isStale) return "secondary"; // 👈 Offline par grey color

//     const sats = parseFloat(satellites);
//     if (isNaN(sats)) return "text";
//     if (sats >= 10) return "success";
//     if (sats >= 5) return "warning";
//     return "error";
//   };

//   // === Handlers (Keeping your exact logic) ===
//   const handleRouteReplay = () => {
//     if (searchQuery.trim()) {
//       dispatch(setIsVehicle(searchQuery.trim()));
//       dispatch(setAutoLoadRoute(true));
//       navigate("/Route-Replay");
//     }
//   };

//   const handleEditDetails = () => {
//     if (searchQuery.trim()) dispatch(setIsVehicle(searchQuery.trim()));
//     navigate("/Create/Edit-Details");
//   };

//   const renderVehicleCard = (vehicle) => (
//     <Card
//       key={vehicle.vehicleNumber}
//       sx={{
//         mb: 2, p: 2, cursor: "pointer",
//         "&:hover": { boxShadow: 3 },
//       }}
//       onClick={() => onVehicleSelect(vehicle.vehicleNumber)}
//     >
//       <MDBox display="flex" justifyContent="space-between" alignItems="center">
//         <MDBox display="flex" flexDirection="column" width="100%">
//           <MDTypography variant="h6" fontWeight="medium" display="flex" alignItems="center" gap={1} flexWrap="wrap">
//             <DirectionsBusIcon fontSize="small" sx={{ color: getVehicleStatusColor(vehicle.ignition, vehicle.speed, vehicle.rawTime) }} />
//             <MDTypography component="span" variant="body1" fontWeight="bold" sx={{ fontSize: "0.85rem" }}>
//               {vehicle.nickName}
//             </MDTypography>
//             <MDTypography component="span" variant="body2" color="text.secondary" sx={{ fontSize: "0.75rem" }}>
//               {vehicle.vehicleNumber}
//             </MDTypography>
//             <MDBox display="flex" alignItems="center" gap={1} ml="auto">
//               {vehicle.tempThing && (
//                 <MDTypography fontWeight="small" fontSize="0.60rem" color="secondary">
//                   Replacement <MDTypography component="span" color="error" fontSize="0.60rem" fontWeight="bold">{vehicle.tempThing}</MDTypography>
//                 </MDTypography>
//               )}
//               <Tooltip title={hasTempLink ? "Update Link" : "Create Link"}>
//                 <IconButton
//                   size="small"
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     openApiModal(hasTempLink ? "update" : "create");
//                   }}
//                   sx={{
//                     color: hasTempLink ? "primary.main" : "text.secondary",
//                   }}
//                 >
//                   <Icon fontSize="small">link</Icon>
//                 </IconButton>
//               </Tooltip>
//               {localStorage.getItem("isLiveCamera") === "true" && (
//                 <Button
//                   variant="contained" size="small" color="error"
//                   startIcon={<Icon>live_tv</Icon>}
//                   onClick={(e) => { e.stopPropagation(); /* openLiveView logic */ }}
//                 >
//                   LIVE VIEW
//                 </Button>
//               )}
//             </MDBox>
//           </MDTypography>

//           <Divider sx={{ my: 1 }} />

//           <MDBox display="flex" alignItems="center" justifyContent="space-between" width="100%">
//             <MDTypography variant="button" color="text">{vehicle.time}</MDTypography>
//             <MDTypography variant="button" color={getSpeedTextColor(vehicle.ignition, vehicle.speed, vehicle.rawTime)} fontWeight="medium" display="flex" alignItems="center" gap={0.5}>
//               <Icon fontSize="small">speed</Icon>
//               {(vehicle.speed * 1.94384).toFixed(2)} knots &nbsp;
//               {getSpeedStatusText(vehicle.ignition, vehicle.speed, vehicle.rawTime)}
//             </MDTypography>
//           </MDBox>
//         </MDBox>
//       </MDBox>

//       <MDBox mt={1.5} display="flex" alignItems="flex-start" gap={3}>
//         <MDTypography variant="button" color={getSpeedTextColor(vehicle.ignition, vehicle.speed, vehicle.rawTime)} display="flex" alignItems="center" gap={0.5} sx={{ whiteSpace: "nowrap" }}>
//           <Icon fontSize="small" color={getSpeedTextColor(vehicle.ignition, vehicle.speed, vehicle.rawTime)}>vpn_key</Icon>
//           Ignition {vehicle.ignition}
//         </MDTypography>
//         {/* <MDTypography variant="button" color="text"><Icon fontSize="small">signal_cellular_alt</Icon> Signal {vehicle.signal}%</MDTypography> */}
//         <MDTypography variant="button" color={getSignalColor(vehicle.signal, vehicle.isStale)} display="flex" alignItems="center" gap={0.5} sx={{ whiteSpace: "nowrap" }}>
//           <Icon fontSize="small" color={getSignalColor(vehicle.signal, vehicle.isStale)}>signal_cellular_alt</Icon> Signal {vehicle.signal}%
//         </MDTypography>
//         {/* <MDTypography variant="button" color="text"><Icon fontSize="small">satellite_alt</Icon> Satellites {vehicle.satellites}</MDTypography> */}
//         <MDTypography variant="button" color={getSatelliteColor(vehicle.satellites, vehicle.isStale)} display="flex" alignItems="center" gap={0.5} sx={{ flex: "0 0 42%", flexShrink: 0, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
//           <Icon fontSize="small" color={getSatelliteColor(vehicle.satellites, vehicle.isStale)}>satellite_alt</Icon> Satellites {vehicle.satellites}
//         </MDTypography>
//       </MDBox>

//       {/* Action Buttons (Visible only when vehicle is searched/selected) */}
//       {selectedVehicleNumber !== undefined && searchQuery === vehicle.vehicleNumber && (
//         <MDBox sx={{ padding: 1, display: "flex", gap: 2, flexWrap: "wrap", mt: 1 }}>
//           <Button variant="outlined" onClick={handleEditDetails} sx={{ fontWeight: 400, border: "1px solid #ccc", color: "rgb(102, 102, 102)" }}>
//             Edit Details
//           </Button>
//           <Button variant="outlined" onClick={handleRouteReplay} sx={{ fontWeight: 400, border: "1px solid #ccc", color: "rgb(102, 102, 102)" }}>
//             Route Replay
//           </Button>
//         </MDBox>
//       )}

//       {/* {vehicle.journeyAvailable && (
//         <>
//           <Divider sx={{ my: 1 }} />
//           <MDBox display="flex" justifyContent="space-between" mb={0.5}>
//             <MDTypography variant="button" fontWeight="medium" color="text">On Route: {vehicle.route}</MDTypography>
//             <MDTypography variant="button" color="success">{vehicle.progress}%</MDTypography>
//           </MDBox>
//           <LinearProgress variant="determinate" color="success" value={vehicle.progress} />
//         </>
//       )} */}
//     </Card>
//   );

//   return (
//     <MDBox
//       pb={3}
//       sx={{
//         maxHeight: { xs: 600, md: 970 },
//         overflowY: "auto",
//         scrollbarWidth: "none",
//         "&::-webkit-scrollbar": { display: "none" },
//       }}
//     >
//       {vehicles.map(renderVehicleCard)}

//       <Dialog
//         open={apiModalOpen}
//         onClose={() => {
//           if (!loading) {
//             setApiModalOpen(false);
//           }
//         }}
//         maxWidth="sm"
//         fullWidth
//       >
//         {/* (Modal content as is) */}
//         <DialogTitle>
//           {apiStep === "confirm" && "Create API Key"}
//           {apiStep === "time" && (tempApiKey ? "Update Link" : "Select Expiry Time")}
//           {apiStep === "success" && "Link Generated"}
//           {apiStep === "delete" && "Delete Temp URL Link"}
//           <IconButton
//             onClick={() => setApiModalOpen(false)}
//             sx={{ position: "absolute", right: 8, top: 8 }}
//           >
//             <Icon>close</Icon>
//           </IconButton>
//         </DialogTitle>

//         <DialogContent dividers>
//           {apiStep === "confirm" && (
//             <MDTypography>Are you sure you want to create an API key?</MDTypography>
//           )}

//           {apiStep === "time" && (
//             <MDBox display="flex" alignItems="center" gap={2} flexWrap="wrap">
//               <Select value={hours} onChange={(e) => setHours(e.target.value)} sx={{ minWidth: 120, height: 40 }}>
//                 {[...Array(25)].map((_, i) => (
//                   <MenuItem key={i} value={i}>
//                     {i} hours
//                   </MenuItem>
//                 ))}
//               </Select>
//               <Select value={minutes} onChange={(e) => setMinutes(e.target.value)} sx={{ minWidth: 120, height: 40 }}>
//                 {Array.from({ length: 60 }, (_, i) => (
//                   <MenuItem key={i} value={i}>
//                     {i} minutes
//                   </MenuItem>
//                 ))}
//               </Select>
//               <Button
//                 variant="contained"
//                 disabled={loading}
//                 onClick={async (e) => {
//                   e.preventDefault();
//                   e.stopPropagation();

//                   if (loading) return;

//                   try {
//                     if (tempApiKey) {
//                       await handleUpdateLink();
//                     } else {
//                       await handleCreateLink();
//                     }
//                   } catch (err) {
//                     console.error(err);
//                   }
//                 }}
//                 sx={{
//                   background: "#FB8C00",
//                   color: "#fff",
//                   minWidth: 120,
//                   height: 40,
//                   "&:hover": {
//                     background: "#ef6c00",
//                   },
//                 }}
//               >
//                 {loading ? "Please Wait..." : "Confirm"}
//               </Button>
//             </MDBox>
//           )}

//           {apiStep === "success" && (
//             <MDBox>
//               <MDTypography variant="body2">Generated Link:</MDTypography>
//               <MDBox
//                 sx={{
//                   bgcolor: "#f5f5f5",
//                   p: 1.5,
//                   borderRadius: 1,
//                   wordBreak: "break-all",
//                   fontFamily: "monospace",
//                 }}
//               >
//                 {tempLink}
//               </MDBox>
//               <MDBox display="flex" gap={1} mt={2}>
//                 <Button
//                   variant="contained"
//                   startIcon={<Icon>content_copy</Icon>}
//                   onClick={() => {
//                     navigator.clipboard.writeText(tempLink);
//                     // alert("Copied!");
//                     openSnackbar("Copied!")
//                   }}
//                   style={{ background: "#FB8C00", color: 'white' }}
//                 >
//                   Copy
//                 </Button>
//                 <Button variant="contained" onClick={() => setApiStep("time")} style={{ background: "#FB8C00", color: 'white' }}>
//                   Update
//                 </Button>
//                 <Button variant="contained" color="error" onClick={() => setApiStep("delete")} style={{ background: "#FB8C00", color: 'white' }}>
//                   Delete
//                 </Button>
//               </MDBox>
//             </MDBox>
//           )}

//           {apiStep === "delete" && (
//             <MDTypography color="error">Are you sure you want to delete this temporary link?</MDTypography>
//           )}
//         </DialogContent>

//         <DialogActions>
//           {apiStep === "confirm" && (
//             <>
//               <Button onClick={() => setApiModalOpen(false)}>Cancel</Button>
//               <Button variant="contained" onClick={() => setApiStep("time")} style={{ background: '#FB8C00', color: 'white' }}>
//                 OK
//               </Button>
//             </>
//           )}
//           {apiStep === "delete" && (
//             <>
//               <Button onClick={() => setApiModalOpen(false)}>Cancel</Button>
//               <Button variant="contained" color="error" onClick={handleDeleteLink}>
//                 Delete
//               </Button>
//             </>
//           )}
//         </DialogActions>
//       </Dialog>
//     </MDBox>
//   );
// }

// Projects.propTypes = {
//   searchQuery: PropTypes.string,
//   onVehicleSelect: PropTypes.func,
// };

// export default Projects;

import { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";

// MUI Components
import {
  Card, Icon, LinearProgress, Button, Divider, Select, MenuItem,
  Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Tooltip, TextField
} from "@mui/material";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";

// Material Dashboard 2 Components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Redux Slices
import { setIsVehicle, setAutoLoadRoute } from "../../../features/vehicle/vehicleSlice";
import { setModalVisible, setModelThing } from "features/planning/planningSlice";

function Projects({ searchQuery, onVehicleSelect }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // 👇 DATA AB DIRECTLY REDUX SE AA RAHA HAI
  const { myThings, latestUpdates, selectedVehicleNumber, activeFilter } = useSelector((state) => state.fleet);
  const things = useSelector((state) => state.things.filterThing || []);
  const sessionToken = useSelector((state) => state.auth?.token || localStorage.getItem("token"));

  // === Existing States (Same as before) ===
  const [apiModalOpen, setApiModalOpen] = useState(false);
  const [apiStep, setApiStep] = useState("confirm");
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(5);
  const [tempLink, setTempLink] = useState("");
  const [tempApiKey, setTempApiKey] = useState("");
  const [loading, setLoading] = useState(false);
  const [journeys, setJourneys] = useState([]);
  const [selectedJourney, setSelectedJourney] = useState("");

  const [streamModalOpen, setStreamModalOpen] = useState(false);
  const [currentVehicleForStream, setCurrentVehicleForStream] = useState("");
  const [activeCameras, setActiveCameras] = useState([]);
  const [loadingStreams, setLoadingStreams] = useState(false);
  const [selectedCameras, setSelectedCameras] = useState([]);
  const [gridSize, setGridSize] = useState(4);
  const [showActiveOnly, setShowActiveOnly] = useState(false);
  const [streamingAction, setStreamingAction] = useState({ loading: false, id: null });
  const [snackbar, setSnackbar] = useState({ open: false, message: "", color: "success" });

  const selectedThing = things.find((e) => e.id === searchQuery);

  // 👈 NEW: tracks which vehicle the Create/Update/Delete Link modal is currently for.
  // No longer depends on card selection — set directly when the link icon is clicked.
  const [linkTargetVehicle, setLinkTargetVehicle] = useState(null);

  const API_BASE = "https://v3.dhundhoo.com";
  // const sessionToken = useSelector((state) => state.auth?.token || localStorage.getItem("token"));

  const apiCall = async (url, method = "POST", body) => {
    setLoading(true);
    try {
      // Ensure raw token is used
      const cleanToken = sessionToken ? sessionToken.replace("Bearer ", "").trim() : "";

      const response = await axios({
        url: url.startsWith("http") ? url : `${API_BASE}${url}`,
        method: method,
        data: body,
        headers: {
          "x-dhundhoo-session": cleanToken,
        },
      });

      // Axios stores the response in .data
      const data = response.data;

      // Check for "Internal Server Error" within a 200 response
      if (data.message === "Internal Server Error" || data.error) {
        throw new Error(data.message || "Backend processing failed");
      }

      return data;
    } catch (err) {
      const errorMsg = err.response?.data?.message || err.message || "API Error";
      alert(errorMsg);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  // === Data Logic (Logic wahi hai, sirf source Redux hai) ===
  const vehicles = useMemo(() => {
    if (!myThings) return [];

    const now = Date.now();

    return Object.entries(myThings)
      .map(([vehicleNumber, data]) => {
        const update = latestUpdates[vehicleNumber];
        const latest = update?.MOBILE || update?.GPS || update?.latest?.MOBILE || update?.latest?.GPS || {};
        const raw = latest?.raw || {};
        const updatedAt = latest?.updatedAt || data?.latest?.MOBILE?.updatedAt || null;

        const journeyAvailable = data?.journeyAvailable === true;
        const journeyData = data?.currentJourney || {};

        return {
          vehicleNumber,
          nickName: data?.thing?.nickName || "N/A",
          name: data?.thing?.name || "N/A",
          ignition: latest?.raw?.IGNITION?.toString() === "1" ? "ON" : "OFF",
          time: updatedAt ? new Date(updatedAt).toLocaleString("en-IN") : "N/A",
          rawTime: updatedAt ? new Date(updatedAt).getTime() : 0,
          // 👈 Offline (stale) flag, used to grey out signal/satellite icons below.
          isStale: !updatedAt || new Date(updatedAt).getTime() + 3600000 < now,
          speed: latest?.speed ? parseFloat(latest.speed) : 0,
          signal: raw?.SIGNAL_STRENGTH ? parseFloat(raw.SIGNAL_STRENGTH).toFixed() : "0",
          satellites: raw?.TOTAL_SATELLITE || 0,
          tempThing: data?.thing?.tempThing || null,
          // 👈 NEW: har vehicle apna khud ka link status carry kare, selection pe depend na ho
          tempApiKey: data?.thing?.tempApiKey || null,
          journeyAvailable,
          route: journeyAvailable ? `${journeyData?.journeyName || "N/A"} ${journeyData?.type || "N/A"}` : "N/A",
          status: data?.journeyStatus || "0 / 0",
          progress: data?.progress || 0,
        };
      })
      .filter((vehicle) => {
        const q = (searchQuery || "").toLowerCase().trim();
        const isStale = vehicle.rawTime + 3600000 < Date.now();

        if (q.startsWith("@") && q !== "@total") {
          if ("@running".startsWith(q)) return !isStale && vehicle.ignition === "ON" && vehicle.speed >= 0.25;
          if ("@idle".startsWith(q)) return !isStale && vehicle.ignition === "ON" && vehicle.speed < 0.25;
          if ("@parked".startsWith(q) || "@stopped".startsWith(q)) return !isStale && vehicle.ignition === "OFF";
          if ("@offline".startsWith(q)) return isStale;
        }

        if (!q || q === "@total") {
          if (activeFilter === "@running") return !isStale && vehicle.ignition === "ON" && vehicle.speed >= 0.25;
          if (activeFilter === "@idle") return !isStale && vehicle.ignition === "ON" && vehicle.speed < 0.25;
          if (activeFilter === "@parked") return !isStale && vehicle.ignition === "OFF";
          if (activeFilter === "@offline") return isStale;
          return true;
        }

        return (
          vehicle.vehicleNumber.toLowerCase().includes(q) ||
          vehicle.nickName.toLowerCase().includes(q) ||
          vehicle.name.toLowerCase().includes(q)
        );
      })
      .sort((a, b) => b.rawTime - a.rawTime);
  }, [myThings, latestUpdates, activeFilter, searchQuery]);

  const handleCreateLink = async () => {
    if (!linkTargetVehicle) {
      alert("Vehicle not selected");
      return;
    }

    try {
      const duration =
        (parseInt(hours) || 0) * 60 +
        (parseInt(minutes) || 0);

      const generatedKey = uuidv4();

      const payload = {
        thingId: linkTargetVehicle,
        tempApiKey: generatedKey,
        expireTimeInMinutes: duration,
      };

      const data = await apiCall(
        "/tempUrl/save",
        "POST",
        payload
      );

      const weblink = `https://boat.routegrip.com/live_temp?apiKey=${generatedKey}&thingId=${linkTargetVehicle}`;

      setTempLink(weblink);

      setTempApiKey(generatedKey);

      setTimeout(() => {
        setApiStep("success");
      }, 100);

    } catch (err) {
      console.error(err);
    }
  };

  const handleUpdateLink = async () => {
    if (!tempApiKey || !linkTargetVehicle) return;
    try {
      const duration = (parseInt(hours) || 0) * 60 + (parseInt(minutes) || 0);

      const payload = {
        thingId: linkTargetVehicle,
        tempApiKey: tempApiKey,
        expireTimeInMinutes: duration,
      };

      await apiCall("/tempUrl/update", "POST", payload);

      // Generate the link for display (same as create logic)
      const weblink = `https://boat.routegrip.com/live_temp?apiKey=${tempApiKey}&thingId=${linkTargetVehicle}`;

      setTempLink(weblink);
      // setApiStep("success");
      setTimeout(() => {
        setApiStep("success");
      }, 100);
      openSnackbar("Temporary URL updated successfully");
    } catch (err) {
      openSnackbar(err.message || "Failed to update URL", "error");
    }
  };

  const handleDeleteLink = async () => {
    if (!tempApiKey || !linkTargetVehicle) return;
    try {
      const payload = {
        thingId: linkTargetVehicle,
        tempApiKey,
      };

      await apiCall("https://camera.dhundhoo.com/tempUrl/delete", "POST", payload);
      alert("Link deleted!");
      setApiModalOpen(false);
    } catch (err) { }
  };

  const resetModal = () => {
    setApiStep("confirm");
    setHours(0);
    setMinutes(30);
    setTempLink("");
    setTempApiKey("");
    setLinkTargetVehicle(null);
  };

  const openSnackbar = (message, color = "success") => {
    setSnackbar({ open: true, message, color });
  };

  const closeSnackbar = () => setSnackbar({ ...snackbar, open: false });

  // 👈 CHANGED: ab har card ka apna vehicleNumber + tempApiKey directly milta hai,
  // isliye card select kiye bina bhi kisi bhi card ke link icon se modal khul sakta hai.
  const openApiModal = (vehicleNumber, existingTempApiKey) => {
    resetModal();
    setLinkTargetVehicle(vehicleNumber);

    if (existingTempApiKey) {
      setTempApiKey(existingTempApiKey);
      setApiStep("time");
    }

    setApiModalOpen(true);
  };

  // === Helper Functions (No changes in logic) ===
  const getVehicleStatusColor = (ignition, speed, rawTime) => {
    const now = Date.now();
    const isStale = rawTime && rawTime + 3600000 < now;
    const spd = speed * 1.852;
    if (isStale) return "secondary";
    if (ignition === "OFF") return "error.main";
    return spd > 0 ? "success.main" : "warning.main";
  };

  const getSpeedStatusText = (ignition, speed, rawTime) => {
    const now = Date.now();
    const isStale = rawTime && rawTime + 3600000 < now;
    const spd = speed * 1.852;
    if (isStale) return "Offline";
    if (ignition === "OFF" && spd === 0) return "Parked";
    if (ignition === "ON" && spd === 0) return "Idle";
    if (ignition === "ON" && spd > 0) return "Running";
    return "N/A";
  };

  const getSpeedTextColor = (ignition, speed, rawTime) => {
    const now = Date.now();
    const isStale = rawTime && rawTime + 3600000 < now;
    const spd = speed * 1.852;
    if (isStale) return "secondary";
    if (ignition === "OFF" && spd === 0) return "error";
    if (ignition === "ON" && spd === 0) return "warning";
    if (ignition === "ON" && spd > 0) return "success";
    return "text";
  };

  // Signal strength (%) -> color: strong = green, moderate = orange, weak = red, offline = grey
  const getSignalColor = (signal, isStale) => {
    if (isStale) return "secondary"; // 👈 Offline par grey color

    const sig = parseFloat(signal);
    if (isNaN(sig)) return "text";
    if (sig >= 70) return "success";
    if (sig >= 40) return "warning";
    return "error";
  };

  // Satellite count -> color: good = green, weak = orange, poor = red, offline = grey
  const getSatelliteColor = (satellites, isStale) => {
    if (isStale) return "secondary"; // 👈 Offline par grey color

    const sats = parseFloat(satellites);
    if (isNaN(sats)) return "text";
    if (sats >= 10) return "success";
    if (sats >= 5) return "warning";
    return "error";
  };

  // === Handlers (Keeping your exact logic) ===
  const handleRouteReplay = () => {
    if (searchQuery.trim()) {
      dispatch(setIsVehicle(searchQuery.trim()));
      dispatch(setAutoLoadRoute(true));
      navigate("/Route-Replay");
    }
  };

  const handleEditDetails = () => {
    if (searchQuery.trim()) dispatch(setIsVehicle(searchQuery.trim()));
    navigate("/Create/Edit-Details");
  };

  const renderVehicleCard = (vehicle) => (
    <Card
      key={vehicle.vehicleNumber}
      sx={{
        mb: 2, p: 2, cursor: "pointer",
        "&:hover": { boxShadow: 3 },
      }}
      onClick={() => onVehicleSelect(vehicle.vehicleNumber)}
    >
      <MDBox display="flex" justifyContent="space-between" alignItems="center">
        <MDBox display="flex" flexDirection="column" width="100%">
          <MDTypography variant="h6" fontWeight="medium" display="flex" alignItems="center" gap={1} flexWrap="wrap">
            <DirectionsBusIcon fontSize="small" sx={{ color: getVehicleStatusColor(vehicle.ignition, vehicle.speed, vehicle.rawTime) }} />
            <MDTypography component="span" variant="body1" fontWeight="bold" sx={{ fontSize: "0.85rem" }}>
              {vehicle.nickName}
            </MDTypography>
            <MDTypography component="span" variant="body2" color="text.secondary" sx={{ fontSize: "0.75rem" }}>
              {vehicle.vehicleNumber}
            </MDTypography>
            <MDBox display="flex" alignItems="center" gap={1} ml="auto">
              {vehicle.tempThing && (
                <MDTypography fontWeight="small" fontSize="0.60rem" color="secondary">
                  Replacement <MDTypography component="span" color="error" fontSize="0.60rem" fontWeight="bold">{vehicle.tempThing}</MDTypography>
                </MDTypography>
              )}
              <Tooltip title={vehicle.tempApiKey ? "Update Link" : "Create Link"}>
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation(); // card select trigger nahi hoga
                    openApiModal(vehicle.vehicleNumber, vehicle.tempApiKey); // is card ka data direct
                  }}
                  sx={{
                    color: vehicle.tempApiKey ? "primary.main" : "text.secondary",
                  }}
                >
                  <Icon fontSize="small">link</Icon>
                </IconButton>
              </Tooltip>
              {localStorage.getItem("isLiveCamera") === "true" && (
                <Button
                  variant="contained" size="small" color="error"
                  startIcon={<Icon>live_tv</Icon>}
                  onClick={(e) => { e.stopPropagation(); }}
                >
                  LIVE VIEW
                </Button>
              )}
            </MDBox>
          </MDTypography>

          <Divider sx={{ my: 1 }} />

          <MDBox display="flex" alignItems="center" justifyContent="space-between" width="100%">
            <MDTypography variant="button" color="text">{vehicle.time}</MDTypography>
            <MDTypography variant="button" color={getSpeedTextColor(vehicle.ignition, vehicle.speed, vehicle.rawTime)} fontWeight="medium" display="flex" alignItems="center" gap={0.5}>
              <Icon fontSize="small">speed</Icon>
              {(vehicle.speed * 1.852).toFixed(2)} knots &nbsp;
              {getSpeedStatusText(vehicle.ignition, vehicle.speed, vehicle.rawTime)}
            </MDTypography>
          </MDBox>
        </MDBox>
      </MDBox>

      <MDBox mt={1.5} display="flex" alignItems="flex-start" gap={3}>
        <MDTypography variant="button" color={getSpeedTextColor(vehicle.ignition, vehicle.speed, vehicle.rawTime)} display="flex" alignItems="center" gap={0.5} sx={{ whiteSpace: "nowrap" }}>
          <Icon fontSize="small" color={getSpeedTextColor(vehicle.ignition, vehicle.speed, vehicle.rawTime)}>vpn_key</Icon>
          Ignition {vehicle.ignition}
        </MDTypography>
        {/* <MDTypography variant="button" color="text"><Icon fontSize="small">signal_cellular_alt</Icon> Signal {vehicle.signal}%</MDTypography> */}
        <MDTypography variant="button" color={getSignalColor(vehicle.signal, vehicle.isStale)} display="flex" alignItems="center" gap={0.5} sx={{ whiteSpace: "nowrap" }}>
          <Icon fontSize="small" color={getSignalColor(vehicle.signal, vehicle.isStale)}>signal_cellular_alt</Icon> Signal {vehicle.signal}%
        </MDTypography>
        {/* <MDTypography variant="button" color="text"><Icon fontSize="small">satellite_alt</Icon> Satellites {vehicle.satellites}</MDTypography> */}
        <MDTypography variant="button" color={getSatelliteColor(vehicle.satellites, vehicle.isStale)} display="flex" alignItems="center" gap={0.5} sx={{ flex: "0 0 42%", flexShrink: 0, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
          <Icon fontSize="small" color={getSatelliteColor(vehicle.satellites, vehicle.isStale)}>satellite_alt</Icon> Satellites {vehicle.satellites}
        </MDTypography>
      </MDBox>

      {/* Action Buttons (Visible only when vehicle is searched/selected) */}
      {selectedVehicleNumber !== undefined && searchQuery === vehicle.vehicleNumber && (
        <MDBox sx={{ padding: 1, display: "flex", gap: 2, flexWrap: "wrap", mt: 1 }}>
          <Button variant="outlined" onClick={handleEditDetails} sx={{ fontWeight: 400, border: "1px solid #ccc", color: "rgb(102, 102, 102)" }}>
            Edit Details
          </Button>
          <Button variant="outlined" onClick={handleRouteReplay} sx={{ fontWeight: 400, border: "1px solid #ccc", color: "rgb(102, 102, 102)" }}>
            Route Replay
          </Button>
        </MDBox>
      )}

      {/* {vehicle.journeyAvailable && (
        <>
          <Divider sx={{ my: 1 }} />
          <MDBox display="flex" justifyContent="space-between" mb={0.5}>
            <MDTypography variant="button" fontWeight="medium" color="text">On Route: {vehicle.route}</MDTypography>
            <MDTypography variant="button" color="success">{vehicle.progress}%</MDTypography>
          </MDBox>
          <LinearProgress variant="determinate" color="success" value={vehicle.progress} />
        </>
      )} */}
    </Card>
  );

  return (
    <MDBox
      pb={3}
      sx={{
        maxHeight: { xs: 600, md: 970 },
        overflowY: "auto",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": { display: "none" },
      }}
    >
      {vehicles.map(renderVehicleCard)}

      <Dialog
        open={apiModalOpen}
        onClose={() => {
          if (!loading) {
            setApiModalOpen(false);
          }
        }}
        maxWidth="sm"
        fullWidth
      >
        {/* (Modal content as is) */}
        <DialogTitle>
          {apiStep === "confirm" && "Create API Key"}
          {apiStep === "time" && (tempApiKey ? "Update Link" : "Select Expiry Time")}
          {apiStep === "success" && "Link Generated"}
          {apiStep === "delete" && "Delete Temp URL Link"}
          <IconButton
            onClick={() => setApiModalOpen(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {apiStep === "confirm" && (
            <MDTypography>Are you sure you want to create an API key?</MDTypography>
          )}

          {apiStep === "time" && (
            <MDBox display="flex" alignItems="center" gap={2} flexWrap="wrap">
              <Select value={hours} onChange={(e) => setHours(e.target.value)} sx={{ minWidth: 120, height: 40 }}>
                {[...Array(25)].map((_, i) => (
                  <MenuItem key={i} value={i}>
                    {i} hours
                  </MenuItem>
                ))}
              </Select>
              <Select value={minutes} onChange={(e) => setMinutes(e.target.value)} sx={{ minWidth: 120, height: 40 }}>
                {Array.from({ length: 60 }, (_, i) => (
                  <MenuItem key={i} value={i}>
                    {i} minutes
                  </MenuItem>
                ))}
              </Select>
              <Button
                variant="contained"
                disabled={loading}
                onClick={async (e) => {
                  e.preventDefault();
                  e.stopPropagation();

                  if (loading) return;

                  try {
                    if (tempApiKey) {
                      await handleUpdateLink();
                    } else {
                      await handleCreateLink();
                    }
                  } catch (err) {
                    console.error(err);
                  }
                }}
                sx={{
                  background: "#FB8C00",
                  color: "#fff",
                  minWidth: 120,
                  height: 40,
                  "&:hover": {
                    background: "#ef6c00",
                  },
                }}
              >
                {loading ? "Please Wait..." : "Confirm"}
              </Button>
            </MDBox>
          )}

          {apiStep === "success" && (
            <MDBox>
              <MDTypography variant="body2">Generated Link:</MDTypography>
              <MDBox
                sx={{
                  bgcolor: "#f5f5f5",
                  p: 1.5,
                  borderRadius: 1,
                  wordBreak: "break-all",
                  fontFamily: "monospace",
                }}
              >
                {tempLink}
              </MDBox>
              <MDBox display="flex" gap={1} mt={2}>
                <Button
                  variant="contained"
                  startIcon={<Icon>content_copy</Icon>}
                  onClick={() => {
                    navigator.clipboard.writeText(tempLink);
                    // alert("Copied!");
                    openSnackbar("Copied!")
                  }}
                  style={{ background: "#FB8C00", color: 'white' }}
                >
                  Copy
                </Button>
                <Button variant="contained" onClick={() => setApiStep("time")} style={{ background: "#FB8C00", color: 'white' }}>
                  Update
                </Button>
                <Button variant="contained" color="error" onClick={() => setApiStep("delete")} style={{ background: "#FB8C00", color: 'white' }}>
                  Delete
                </Button>
              </MDBox>
            </MDBox>
          )}

          {apiStep === "delete" && (
            <MDTypography color="error">Are you sure you want to delete this temporary link?</MDTypography>
          )}
        </DialogContent>

        <DialogActions>
          {apiStep === "confirm" && (
            <>
              <Button onClick={() => setApiModalOpen(false)}>Cancel</Button>
              <Button variant="contained" onClick={() => setApiStep("time")} style={{ background: '#FB8C00', color: 'white' }}>
                OK
              </Button>
            </>
          )}
          {apiStep === "delete" && (
            <>
              <Button onClick={() => setApiModalOpen(false)}>Cancel</Button>
              <Button variant="contained" color="error" onClick={handleDeleteLink}>
                Delete
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </MDBox>
  );
}

Projects.propTypes = {
  searchQuery: PropTypes.string,
  onVehicleSelect: PropTypes.func,
};

export default Projects;